module.exports={CapabilitiesAffected:"영향을 받는 기능:",ShowRelated:"관련 항목 {relatedCount}개 표시"};